import React from "react";
import {ClockLoader} from "react-spinners";


const BaseContentLoader = () => {
    return (
        <div className={'d-flex align-items-center justify-content-center'}
             style={{height:'100vh'}}>
            <div className="">
                <ClockLoader color={'var(--primary)'} size={100} loading={true}/>
            </div>
        </div>
    )
};
export default BaseContentLoader;
